export default {
    initial_forecast_row_count: 60,
    previous_month_count: 1,
    future_month_count: 10,
    bench_overview_previous_month_count: 0,
    bench_overview_future_month_count: 9,
    load_more_height: 471,
    // load_more_height_report: 737,
    load_more_height_report: 1320,
    client_id: {
        //development: "46af53f4-44f1-48d1-b516-54e1fb016e04",
        //production: "490de9ef-9305-41a5-88d2-6be310359474" //not using right now
        development: "4c90c6ba-4d71-40b4-a071-78c31f683c2a",
        production: "f9aa5520-0b72-46fb-a0e4-950e620bcfa0"
    }
};
